import React from 'react';
import { Warehouse, ArrowRight } from 'lucide-react';

// Announcement banner — Scarborough warehouse & retail location, move-in Oct 1, 2026.
// (Replaced the free-mill-file promo, which auto-expired Aug 11, 2026.)
// When the grand-opening launch date is set, swap this copy for the launch countdown.
const PromoBanner: React.FC = () => {
  return (
    <div
      className="bg-forge text-paper-warm print:hidden relative"
      role="region"
      aria-label="Scarborough warehouse announcement"
    >
      {/* Top brass accent stripe — signals 'important news above the navigation' */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brass to-transparent" />

      <div className="max-w-editorial mx-auto px-4 sm:px-6 lg:px-10 py-3 sm:py-3.5 flex items-center gap-3 sm:gap-5">
        {/* Icon + eyebrow */}
        <div className="flex items-center gap-2.5 shrink-0">
          <Warehouse className="w-4 h-4 sm:w-5 sm:h-5 text-brass" strokeWidth={1.5} />
          <span className="hidden md:inline font-mono text-[10px] tracking-micro uppercase text-brass">
            Now in Scarborough
          </span>
        </div>

        {/* Message */}
        <p className="text-sm sm:text-[15px] text-paper-warm flex-1 min-w-0 leading-snug">
          <span className="font-editorial italic">We&apos;re in.</span>
          <span className="hidden sm:inline text-paper/85">
            {' '}— 345 Nugget Ave, Unit 17, Scarborough. Free order pickup now available.
          </span>
          <span className="sm:hidden text-paper/85">
            {' '}— 345 Nugget Ave · free pickup.
          </span>
        </p>

        {/* CTA — routes to the announcement on the news page. */}
        <a
          href="/news"
          className="inline-flex items-center gap-1.5 bg-ember hover:bg-ember-deep text-paper-warm text-sm font-medium px-3.5 sm:px-4 py-1.5 sm:py-2 transition-colors duration-150 shrink-0"
        >
          <span className="hidden sm:inline">Read the news</span>
          <span className="sm:hidden">News</span>
          <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.75} />
        </a>
      </div>
    </div>
  );
};

export default PromoBanner;
